import {
  GAUGE_GRID_GAP,
  GAUGE_ITEM_WIDTH,
  LEFT_PANEL_MIN_WIDTH,
  MAX_RESIZED_GAUGE_GRID_COLUMNS,
  RESIZE_HANDLE_WIDTH
} from './panelResizeConstants';

export function getMaxLeftPanelWidth(columnCount: number) {
  return columnCount * GAUGE_ITEM_WIDTH + (columnCount - 1) * GAUGE_GRID_GAP;
}

export function getGaugeGridColumnCount(
  panelWidth: number,
  maxColumns: number
) {
  const fitColumns = Math.floor(
    (panelWidth + GAUGE_GRID_GAP) / (GAUGE_ITEM_WIDTH + GAUGE_GRID_GAP)
  );

  return Math.max(1, Math.min(maxColumns, fitColumns));
}

export function getPanelResizeBounds(
  containerWidth: number,
  rightPanelMinWidth: number,
  maxGaugeColumns = MAX_RESIZED_GAUGE_GRID_COLUMNS
) {
  const spaceMax = containerWidth - rightPanelMinWidth - RESIZE_HANDLE_WIDTH;
  const columnMax = getMaxLeftPanelWidth(maxGaugeColumns);
  const max = Math.min(spaceMax, columnMax);

  return {
    min: LEFT_PANEL_MIN_WIDTH,
    max: Math.max(LEFT_PANEL_MIN_WIDTH, max)
  };
}
